import React from 'react';
import CasinoCarouselRanking from 'nike-ui/src/components/casino/CasinoCarouselRanking';
import { LeaderboardTime } from './CasinoLeaderboardTime';
import { LeaderboardName } from './CasinoLeaderboardName';
import Accordion from '../turboLive/components/Accordion';
import clsx from 'clsx';
import './CasinoCarouselModule.less';
import { LoaderOrangeRings } from '../loaders/loaderOrangeRings/LoaderOrangeRings';
import { NikeCasinoApi } from '../../types/generated/nike-casino-api';
import { useCasinoTournamentCarousel } from './api';
import { isMobileChannel } from '../../common/util';

const CasinoCarouselModule = () => {
    const { data, status } = useCasinoTournamentCarousel();

    if (status === 'loading') {
        return (
            <div className="py-20">
                <LoaderOrangeRings />
            </div>
        );
    }

    if (!data?.leaderboards?.length) {
        return null;
    }

    return (
        <div className={'mb-30'}>
            {data.leaderboards.map(leaderboard => {
                return <CasinoCarouselRankingModule key={leaderboard.name} leaderboard={leaderboard} />;
            })}
        </div>
    );
};

const CasinoCarouselRankingModule = ({ leaderboard }: { leaderboard: NikeCasinoApi.CarouselLeaderboardDto }) => {
    const tournamentCarouselStart = leaderboard.start;
    const tournamentCarouselEnd = leaderboard.end;
    const tournamentCarouselName = leaderboard.name;
    const tournamentCarouselEntries = leaderboard.entries;
    const isMobile = isMobileChannel();

    if (!tournamentCarouselEntries.length) {
        return null;
    }

    return (
        <Accordion
            otherClass={'bg-orange px-10 p-rel'}
            accordionClass={'mb-10'}
            content={<LeaderboardName name={tournamentCarouselName} />}
        >
            <div className={clsx('bg-black-3 mb-20 pt-20 nui-carousel-leaderboard', { 'px-20 pb-20': !isMobile })}>
                <div className={clsx({ 'px-10': isMobile })}>
                    <LeaderboardTime start={tournamentCarouselStart} end={tournamentCarouselEnd} />
                </div>
                <CasinoCarouselRanking leaderboardEntries={tournamentCarouselEntries} />
            </div>
        </Accordion>
    );
};

export default CasinoCarouselModule;
